import React from "react";
import ReactSelect from "react-select";

export default function Select(props) {
    let {options = [], value, onChange, disabled = false} = props;

    return <select
        disabled={disabled}
        value={value || ''}
        onChange={event => {
            let newValue = event.target.value;
            // console.log('change select value', newValue);
            onChange(newValue);
        }}
    >
        <option value="">Не выбрано</option>
        {
            options.map(item => <option key={item.id} value={item.id}>
                {item.name}
            </option>)
        }
    </select>
}

export function SelectMultiple(props) {
    let itemToSelectValue = item => ({value: item.id, label: item.name});

    let {options = [], value, onChange, disabled = false} = props;
    let localValue = value.map(id => itemToSelectValue(options.find(item => item.id === id)));
    // console.log('local value', localValue);

    return <div>
        <ReactSelect
            value={localValue || []}
            isMulti={true}
            options={options.map(itemToSelectValue)}
            onChange={newValue => {
                if (newValue === null) {
                    newValue = [];
                }
                onChange(newValue.map(item => item.value));
            }}
        />
    </div>
}